import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Container, Row, Col} from 'react-bootstrap';
import {css} from 'aphrodite';

import Isi from 'components/Isi';
import Markdown from 'components/Markdown';

import './styles.scss';

export const Faq = ({settings, styleSheet}) => {
  let linkRenderer = (props) => {
    return (<a
      href={props.href}
      rel='noopener noreferrer'
      className={css(styleSheet.faqLink)}
    >
      {props.children}
    </a>);
  };
  if (settings.faq.content.linkNewTab) {
    linkRenderer = (props) => {
      // Do not open links to elements in a new tab.
      const target = props.href?.charAt(0) === '#' ? null : '_blank';
      return (<a
        rel='noopener noreferrer'
        href={props.href}
        target={target}
        className={css(styleSheet.faqLink)}
      >
        {props.children}
      </a>);
    };
  }

  const tableRenderer = (props) => {
    return <table className='table table-striped faq'>{props.children}</table>;
  }

  return (
    <main id="main-content" data-component={'Faq'}>
      <Container>
        <Row>
          {settings.faq.content.preface && (
            <div className={css(styleSheet.faqPreface)}>
              <Markdown>
                {settings.faq.content.preface}
              </Markdown>
            </div>
          )}
          <Col className={css(styleSheet.faq)} sm={12}>
            <Markdown components={{
              a: linkRenderer,
              table: tableRenderer
            }}>
              {settings.faq.content.markdown}
            </Markdown>
          </Col>
        </Row>
        <Isi settings={settings.isi} styleSheet={styleSheet} />
        {settings.content.bottomSection && (
          <Row>
            <div className={css(styleSheet.bottomSection)}>
              <Markdown>
                {settings.content.bottomSection.markdown}
              </Markdown>
            </div>
          </Row>
        )}
      </Container>
    </main>
  );
};

Faq.propTypes = {
  settings: PropTypes.object.isRequired,
  styleSheet: PropTypes.object.isRequired,
};

const mapStateToProps = function (state) {
  const {settings} = state;

  return {
    settings: settings.get('settings').toJS(),
  };
};

export default connect(mapStateToProps)(Faq);
